import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "vrova-consent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [manage, setManage] = useState(false);
  const [prefs, setPrefs] = useState({ analytics: true, marketing: false });

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const save = (value) => {
    localStorage.setItem(KEY, JSON.stringify(value));
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-consent-banner"
          initial={{ y: 80, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-5 left-5 right-5 md:right-auto md:max-w-md z-[60] rounded-2xl border border-white/10 backdrop-blur-2xl bg-[#0a0a0e]/90 p-6 shadow-2xl"
        >
          <p className="text-sm font-medium mb-2">Cookies & Privacy</p>
          <p className="text-xs text-zinc-400 font-light leading-relaxed mb-5">
            We use essential cookies to run this site, and optional cookies to understand how it's used and improve your experience.
          </p>
          {manage && (
            <div className="space-y-3 mb-5">
              {[["analytics", "Analytics — anonymous usage insights"], ["marketing", "Marketing — relevant updates & campaigns"]].map(([key, label]) => (
                <label key={key} className="flex items-center gap-3 cursor-pointer !mb-0 !normal-case !tracking-normal !text-xs !text-zinc-300 !font-sans">
                  <input type="checkbox" data-testid={`cookie-toggle-${key}`} checked={prefs[key]}
                    onChange={(e) => setPrefs({ ...prefs, [key]: e.target.checked })}
                    className="!w-4 !h-4 !p-0 accent-white" />
                  {label}
                </label>
              ))}
            </div>
          )}
          <div className="flex flex-wrap gap-2.5">
            <button data-testid="cookie-accept-all" onClick={() => save({ essential: true, analytics: true, marketing: true })}
              className="px-5 py-2.5 rounded-full bg-white text-black text-xs font-medium hover:bg-zinc-200 transition-colors">
              Accept All
            </button>
            <button data-testid="cookie-reject" onClick={() => save({ essential: true, analytics: false, marketing: false })}
              className="px-5 py-2.5 rounded-full border border-white/20 text-xs hover:bg-white/10 transition-colors">
              Reject Non-Essential
            </button>
            {manage ? (
              <button data-testid="cookie-save-preferences" onClick={() => save({ essential: true, ...prefs })}
                className="px-5 py-2.5 rounded-full border border-white/20 text-xs hover:bg-white/10 transition-colors">
                Save Preferences
              </button>
            ) : (
              <button data-testid="cookie-manage" onClick={() => setManage(true)}
                className="px-5 py-2.5 rounded-full text-xs text-zinc-400 hover:text-white transition-colors">
                Manage Preferences
              </button>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
